import { Component, Output, Input, EventEmitter } from '@angular/core';
import * as L from 'leaflet';
import { Control, DivIcon, LatLng } from 'leaflet';
import { LatLngCoordinate } from 'src/app/models/lat-lng-coordinate.model';
@Component({
  selector: 'app-map-osm',
  templateUrl: './map-osm.component.html',
  styleUrls: ['./map-osm.component.scss'],
})
export class MapOsmComponent {
  @Output() onclickmarker = new EventEmitter<any>();
  @Output() ondrawremove = new EventEmitter<any>();
  @Output() ondraw = new EventEmitter<any>();
  @Output() onclick = new EventEmitter<any>();

  markers: any = [];
  featureGroup = L.featureGroup();
  showElement = false;
  innercenter!: LatLng;
  innerzoom = 12;

  remaxIcon: DivIcon = L.icon({
    iconUrl: 'assets/images/portales/remax-balloon.svg',
    iconSize: [31, 39],
  });

  options = {
    layers: [
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: 'Open Street Map',
      }),
      this.featureGroup,
    ],
  };

  drawOptions: Control.DrawConstructorOptions = {
    position: 'topleft',
    draw: {
      polyline: false,
      rectangle: false,
      marker: false,
      circle: false,
      circlemarker: false,
    },
    edit: {
      featureGroup: this.featureGroup,
      edit: false,
    },
  };

  private _coords: any;
  @Input() set coords(value: any) {
    this._coords = value;
    this.markers = [];
    if (this._coords !== undefined) {
      // Icono SVG de RE/MAX
      this._coords.forEach((coord: any) => {
        this.markers.push(
          L.marker([coord.lat, coord.lng], {
            icon: this.remaxIcon,
          }).on('click', (ev: any) => {
            this.handleEvent(ev, coord.id);
          })
        );
      });
    }
  }
  get coords(): any {
    return this._coords;
  }

  private readonly _center: any;
  @Input() set center(coords: any) {
    if (coords) {
      this.innercenter = L.latLng(coords.lat, coords.lng);
    }
  }
  get center(): any {
    return this._center;
  }

  private _zoom: any;
  @Input() set zoom(zoom: any) {
    this.innerzoom = zoom;
    this._zoom = zoom;
  }
  get zoom(): any {
    return this._zoom;
  }

  _candraw: any;
  @Input() set candraw(candraw: any) {
    this._candraw = candraw;
  }
  get candraw(): any {
    return this._candraw;
  }

  private readonly _draw: any;
  @Input() set draw(draw: any) {
    const pointList: any = [];
    if (draw !== undefined && draw !== null) {
      draw.forEach((coord: any) => {
        // Mongo almacena los valores como lng, lat
        // Angular los usa como lat, lng
        pointList.push(new L.LatLng(coord[1], coord[0]));
      });
      this.getDrawnPolygonCentroid(draw);
    }

    this.featureGroup.addLayer(L.polygon(pointList));
  }
  get draw(): any {
    return this._draw;
  }

  onDrawCreated(e: any): void {
    const response: any = [];
    e.layer._latlngs[0].forEach((single: any) => {
      response.push([single.lng, single.lat]);
    });
    this.ondraw.emit(response);
  }

  onDrawStarted(e: any): void {
    this.featureGroup.clearLayers();
  }

  onDrawDelete(e: any): void {
    this.ondrawremove.emit(e);
  }

  handleEvent(clickEvent: any, id: any): void {
    this.onclickmarker.emit(id);
  }

  onClick(event: any): void {
    this.onclick.emit(event.latlng);
  }

  getDrawnPolygonCentroid(draw: any): void {
    // Calcular centroid de polígono dibujado
    if (draw.length > 0) {
      const coordsLng: number[] = [];
      const coordsLat: number[] = [];
      draw.forEach((coord: any) => {
        coordsLng.push(coord[0]);
        coordsLat.push(coord[1]);
      });
      const centerLatLng: LatLngCoordinate = {
        lat: this.getAverageFromNumbers(coordsLat),
        lng: this.getAverageFromNumbers(coordsLng),
      };
      this.center = centerLatLng;
    }
  }

  getAverageFromNumbers(coords: number[]): number {
    return coords.reduce((a, b) => a + b, 0) / coords.length;
  }
}
